import React from "react";

const StartDateLogo: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={51}
    height={51}
    viewBox="0 0 51 51"
    fill="none"
    {...props}
  >
    <path
      d="M44.625 21.25H6.375M34 4.25v8.5m-17-8.5v8.5m5.313 17l3.187-2.125V38.25m-2.656 0h5.312m-11.581 8.5h17.85c3.57 0 5.356 0 6.72-.695a6.376 6.376 0 002.785-2.786c.695-1.363.695-3.149.695-6.719V18.7c0-3.57 0-5.355-.695-6.72a6.375 6.375 0 00-2.786-2.785C39.781 8.5 37.995 8.5 34.425 8.5h-17.85c-3.57 0-5.355 0-6.72.695A6.375 6.375 0 007.07 11.98c-.695 1.364-.695 3.149-.695 6.719v17.85c0 3.57 0 5.356.695 6.72a6.375 6.375 0 002.786 2.785c1.364.695 3.149.695 6.719.695z"
      stroke="#8065C9"
      strokeWidth={3.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default StartDateLogo;
